// src/App.js
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Common/master/Layout';
import Home from './pages/auth/Home';
import About from './pages/auth/About';
import Login from './pages/auth/login/Login';
import Signup from './pages/auth/signup/Signup';
import Dashboard from './pages/dashboard/Dashboard';
// Labeling
import ClassificationLabel from './pages/management/labelManagement/classificationLabel/ClassificationLabel';
import DetectionLabel from './pages/management/labelManagement/detectionLabel/DetectionLabel';
import SegmentationLabel from './pages/management/labelManagement/segmentationLabel/SegmentationLabel';
// MANAGEMENT MENUS
// import FaceRecognitionManagement from './pages/management/faceRecognitionManagment/FaceRecognitionManagement';
import ProjectManagement from './pages/management/projectManagement/ProjectManagement.jsx';
import ModelManagement from './pages/management/modelManagement/ModelManagement.jsx';
import ModelTrainingResult from './pages/management/modelManagement/ModelTrainingResult.jsx';
import PublicModelHub from './pages/management/modelHub/PublicModelHub.jsx';
// Dataset prep (upstream of labeling)
import VideoToImages from './pages/management/videoToImages/VideoToImages.jsx';
import Assistant from './pages/assistant/Assistant';
// Prediction
import Prediction from './pages/prediction/Prediction';
// Settings
import ConnectedServices from './pages/settings/ConnectedServices';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route: No Layout */}
        <Route index element={<Login />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/" element={<Layout />}>

          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/Assistant" element={<Assistant />} />

          {/* MANAGEMENT */}
          {/* <Route path="/FaceRecognitionManagement" element={<FaceRecognitionManagement />} /> */}
          <Route path="/ProjectManagement" element={<ProjectManagement />} />
          <Route path="/ModelManagement" element={<ModelManagement />} />
          <Route path="/ModelHub" element={<PublicModelHub />} />
          <Route path="/ModelTrainingResult" element={<ModelTrainingResult />} />

          {/* DATASET PREP */}
          <Route path="/VideoToImages" element={<VideoToImages />} />

          {/* // Labeling */}
          <Route path="ClassificationLabel" element={<ClassificationLabel />} />
          <Route path="DetectionLabel" element={<DetectionLabel />} />
          <Route path="SegmentationLabel" element={<SegmentationLabel />} />

          {/* // Prediction */}
          <Route path="Prediction" element={<Prediction />} />

          {/* SETTINGS — inside the Layout: it reads the signed-in session. */}
          <Route path="/ConnectedServices" element={<ConnectedServices />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
